import { languages } from '@data/static/languages';
import { currencies } from '@data/static/currencies';
export const isValidLanguage = (language) => languages.some((lang) => lang.code === language);
const currenciesValues = currencies.map((x) => x.value);
const HYPHENATED_LANGUAGES = new Set([
    'pt-br',
    'pt-pt',
    'es-es',
    'en-gb',
    'zh-cn',
    'zh-tw',
]);
export const getNavigatorLanguage = () => {
    try {
        if (typeof navigator === 'undefined' || !navigator.language) {
            return undefined;
        }
        const lang = navigator.language.toLowerCase();
        if (HYPHENATED_LANGUAGES.has(lang)) {
            return lang;
        }
        const [language] = navigator.language.split('-');
        return isValidLanguage(language) ? language : undefined;
    }
    catch (error) {
        console.error('Error getting navigator language:', error);
        return undefined;
    }
};
export const getDocumentLanguage = () => {
    try {
        if (typeof document === 'undefined' || !document.documentElement) {
            return undefined;
        }
        const lang = document.documentElement.lang.toLocaleLowerCase();
        if (lang === 'pt') {
            return 'pt-br';
        }
        return isValidLanguage(lang) ? lang : undefined;
    }
    catch (error) {
        console.error('Error getting document language:', error);
        return undefined;
    }
};
export const DefaultLanguage = 'en';
export const DefaultLocale = 'en-US';
